"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.clearFilteredPhones = clearFilteredPhones;
exports.deleteOrderViewConfig = deleteOrderViewConfig;
exports.exportFilteredPhones = exportFilteredPhones;
exports.getFilteredPhones = getFilteredPhones;
exports.getOrderViewConfigDetail = getOrderViewConfigDetail;
exports.getOrderViewConfigList = getOrderViewConfigList;
exports.importFilteredPhones = importFilteredPhones;
exports.saveOrderViewConfig = saveOrderViewConfig;
exports.setFilteredPhones = setFilteredPhones;
var _request = _interopRequireDefault(require("@/utils/request"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * 获取配置列表
 */
function getOrderViewConfigList() {
  return (0, _request.default)({
    url: '/admin/order/view/config/list',
    method: 'get'
  });
}

/**
 * 保存或更新配置
 * @param {Object} data
 */
function saveOrderViewConfig(data) {
  return (0, _request.default)({
    url: '/admin/order/view/config/save',
    method: 'post',
    data: data
  });
}

/**
 * 删除配置
 * @param {number} id
 */
function deleteOrderViewConfig(id) {
  return (0, _request.default)({
    url: "/admin/order/view/config/delete/".concat(id),
    method: 'delete'
  });
}

/**
 * 获取单个配置详情（实时）
 * @param {number} id
 */
function getOrderViewConfigDetail(id) {
  return (0, _request.default)({
    url: "/admin/order/view/config/detail/".concat(id),
    method: 'get'
  });
}

/**
 * 获取已过滤的手机号列表
 * @param {number} configId
 */
function getFilteredPhones(configId) {
  return (0, _request.default)({
    url: "/admin/order/view/config/filtered/phones/".concat(configId),
    method: 'get'
  });
}

/**
 * 设置过滤用户手机号
 * @param {number} configId
 * @param {Array} phones
 */
function setFilteredPhones(configId, phones) {
  return (0, _request.default)({
    url: '/admin/order/view/config/filtered/phones',
    method: 'post',
    data: {
      configId: configId,
      phones: phones
    }
  });
}

/**
 * 导出过滤手机号Excel
 * @param {number} configId
 */
function exportFilteredPhones(configId) {
  return (0, _request.default)({
    url: "/admin/order/view/config/export/phones/".concat(configId),
    method: 'get'
  });
}

/**
 * 批量导入过滤手机号
 * @param {number} configId
 * @param {Array} phones
 */
function importFilteredPhones(configId, phones) {
  return (0, _request.default)({
    url: "/admin/order/view/config/filtered/phones/import/".concat(configId),
    method: 'post',
    data: phones
  });
}

/**
 * 清空过滤用户
 * @param {number} configId
 */
function clearFilteredPhones(configId) {
  return (0, _request.default)({
    url: "/admin/order/view/config/filtered/phones/clear/".concat(configId),
    method: 'delete'
  });
}